import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify);

const themes = {
  theme: {
    themes: {
      light: {
        primary: '#02a2b7',
        secondary: '#222222',
        accent: '#02a2b7',
        error: '#FF5252',
        info: '#02a2b7',
        success: '#4CAF50',
        warning: '#FFC107'
      }
    }
  }
};

export default new Vuetify(themes);
